import React from 'react'

import axios from 'axios'
import url from 'utils/url'
import { alerta } from 'components/Alert/index'

const token = localStorage.getItem('token')
    ? JSON.parse(localStorage.getItem('token'))
    : null

const http = axios.create({
    baseURL: url,
    headers: {Authorization: `Bearer ${token}`},
})

// 401 tem dois significados nesta API e eles NÃO podem ser tratados igual:
//
//  - sessão morta (token ausente, inválido ou revogado): quem responde é o
//    middleware auth:sanctum, com {"message":"Unauthenticated."} — sem o envelope
//    da trait ApiResponser, portanto sem o campo `success`. Aqui sim a sessão caiu.
//
//  - "Você não possui permissão para X": as actions checam a permissão e devolvem
//    401 pela ApiResponser, com {success:false,message}. É erro de tela, não de
//    sessão. Derrubar a sessão nesse caso era o que deslogava o subadmin ao entrar
//    num menu cuja tela chama um endpoint que ele não acessa (ex.: Caixa carrega
//    /lancamentos, Venda carrega /loterias e /usuarios).
const sessaoExpirada = (resposta) => resposta?.data?.success === undefined

http.interceptors.response.use((response) => {
    return response
}, (error) => {

    if (error.response.status == 429) {
        alerta({ success: false, message: 'Aguarde, muitas solicitações foram realizadas!' })
    }

    // Banca bloqueada por inadimplência da mensalidade: o token continua válido,
    // mas o acesso caiu — avisa e derruba a sessão que já estava aberta.
    if (error.response.status === 403 && error.response.data?.bloqueio_mensalidade) {
        alerta({ success: false, message: error.response.data.message })

        setTimeout(() => {
            localStorage.clear();
            window.location = '/login';
        }, 3000);

        // Não repassa o erro: a tela está saindo, evita alerta duplicado.
        return new Promise(() => {})
    }

    if (error.response.status === 401 && sessaoExpirada(error.response)) {
        localStorage.clear();
        window.location = '/login';

        // Não repassa o erro: a tela está saindo.
        return new Promise(() => {})
    }

    return Promise.reject(error)
})

export default http
